import { createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
import { sessionService } from 'redux-react-session';
import createRootReducer from './reducers';
import * as actionware from 'actionware';
import { connectRouter, routerMiddleware } from 'connected-react-router/immutable';
import { getConfig } from './common/config';

export const history = createBrowserHistory();

const initialState = {};
const enhancers = [];
const middleware = [routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(
  createRootReducer(history),
  initialState,
  composedEnhancers
);

const validateSession = async () => {
  try {
    const baseURL = getConfig('GRIFFIN_BASE_API_URL');
    const res = await fetch(`${baseURL}/apis/whoami`, { credentials: 'include' });
    return res.ok;
  } catch (e) {
    return false;
  }
}


const options = { refreshOnCheckAuth: true, redirectPath: '/', driver: 'COOKIES', validateSession };

sessionService.initSessionService(store, options);

actionware.setup({ store });

export default store;
